import React, { useState } from 'react';
import './PropertyDescription.css';

function PropertyDescription({ description }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const shouldTruncate = description.length > 400;
  const displayText = isExpanded || !shouldTruncate
    ? description
    : description.substring(0, 400) + '...';

  return (
    <div className="property-description">
      <h2 className="section-title">Description</h2>

      <div className="description-content">
        <p className="description-text">{displayText}</p>

        {shouldTruncate && (
          <button
            className="btn-read-more"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            {isExpanded ? 'Show Less' : 'Read More'}
          </button>
        )}
      </div>
    </div>
  );
}

export default PropertyDescription;
